import { Gauge } from 'lucide-react';
import PressureVoice from './PressureVoice';
import { PN, PMIN, fmtBar } from '../lib/pressure';
import UnitInput from './UnitInput';
import { len, press as pressFmt } from '../lib/units';


// static pressure (Soll) from elevation + measured pressure (Ist) diagnosis
export default function PressureBox({ t, obj, patch, project, updateProject, press }) {
  const cfg = project.pressure || {};
  const isSrc = cfg.srcId === obj.id;
  const setCfg = (p) => updateProject((pr) => ({ ...pr, pressure: { ...(pr.pressure || {}), ...p } }));
  const n = press?.nodes[obj.id];
  const fill = (s, v) => s.replace('{x}', v);
  return (
    <div className={`fx-box pr-box pr-${n?.leak ? 'leak' : n?.status || 'none'}`} data-testid="pressure-box">
      <b><Gauge size={14} /> {t.prTitle}</b>
      {isSrc ? (
        <div className="sw-grid">
          <label>{t.prRef}<UnitInput kind="press" testid="pressure-ref-input" value={cfg.bar} onChange={(bar) => setCfg({ bar })} /></label>
          <label>{t.prPn}<select data-testid="pressure-pn-select" value={cfg.pn || 10} onChange={(e) => setCfg({ pn: +e.target.value })}>{PN.map((v) => <option key={v} value={v}>PN {v}</option>)}</select></label>
          <label>{t.prMode}<select data-testid="pressure-mode-select" value={cfg.mode || 'drink'} onChange={(e) => setCfg({ mode: e.target.value, min: '' })}><option value="drink">{t.prDrink}</option><option value="irr">{t.prIrr}</option></select></label>
          <label>{t.prMin}<UnitInput kind="press" testid="pressure-min-input" value={cfg.min} ph={fmtBar(PMIN[cfg.mode || 'drink'])} onChange={(min) => setCfg({ min })} /></label>
          <button className="btn btn-outline btn-sm" data-testid="pressure-src-clear" onClick={() => setCfg({ srcId: null })}>{t.prSrcClear}</button>
        </div>
      ) : <button className="btn btn-dark btn-sm" data-testid="pressure-src-btn" onClick={() => setCfg({ srcId: obj.id, pn: cfg.pn || 10, mode: cfg.mode || 'drink' })}>{t.prSrcSet}</button>}
      {press && !n && !isSrc && <small className="muted" data-testid="pressure-no-elev">{t.prNoElev}</small>}
      {!isSrc && <PressureVoice t={t} />}
      {!n && !isSrc && <label className="pr-ist">{t.prIst}<UnitInput kind="press" testid="pressure-ist-input" value={obj.pIst} onChange={(pIst) => patch({ pIst })} /></label>}
      {!n && !isSrc && obj.pIst != null && obj.pIst !== '' && <small className="muted" data-testid="pressure-raw-hint">{t.prRawHint}</small>}
      {!press && isSrc && <small className="muted" data-testid="pressure-need">{t.prNeed}</small>}
      {n && (
        <>
          <p className="sw-res" data-testid="pressure-soll">{t.prSoll}: <b>{fmtBar(n.bar)}</b> · {len(n.z, 2)} {t.aslShort}</p>
          {n.status === 'over' && <p className="pr-alert over" data-testid="pressure-over">⛔ {fill(t.prOver, `PN ${press.pn}`)}</p>}
          {n.status === 'low' && <p className="pr-alert low" data-testid="pressure-low">⚠️ {fill(t.prLow, fmtBar(press.min))}</p>}
          {!isSrc && <label className="pr-ist">{t.prIst}<UnitInput kind="press" testid="pressure-ist-input" value={obj.pIst} onChange={(pIst) => patch({ pIst })} /></label>}
          {n.drop != null && <small data-testid="pressure-delta">Δ {fmtBar(n.drop)}</small>}
          {n.leak && <p className="pr-alert over" data-testid="pressure-leak-diag">⚠️ {fill(t.prLeakDiag, pressFmt(n.drop, 1).split(' ')[0])}</p>}
          {n.quiet && <p className="pr-alert quiet" data-testid="pressure-quiet">🔇 {t.prQuiet}</p>}
        </>
      )}
    </div>
  );
}
